/**
 * Navigation configuration for the Sidebar component.
 * Maps all existing SideMenu routes to the new Sidebar structure.
 */

export const sidebarNav = {
  sectionLabel: "Discover",
  items: [
    {
      key: "company",
      label: "Company",
      icon: "building",
      route: "/CompanyMenuDetails",
    },
    {
      key: "files",
      label: "Files",
      icon: "file",
      requiresFullAccess: true, // hidden when ExcludeDeparmentalActions is true
      popout: [
        { label: "Companies", route: "/CompaniesLanding" },
        { label: "eBinders", route: "/EbinderMainLanding" },
        { label: "Individuals & Entities", route: "/IndividualEntitiesLanding" },
        { label: "Unit Trusts", route: "/UnitTrustRegisterLanding" },
        { label: "Joint Holders", route: "/JointHolderLanding" },
        { label: "Business Names", route: "/BusinessNameLanding" },
        { label: "Director ID", route: "/DIDListLanding" },
      ],
    },
    {
      key: "monitors",
      label: "Monitors",
      icon: "monitor",
      requiresFullAccess: true,
      popout: [
        { label: "Annual Statements", route: "/MonitorLanding" },
        { label: "ASIC Debts", route: "/ASICDeptLanding" },
        { label: "Orders", route: "/OrderMonitorLanding" },
        { label: "Digital Signatures", route: "/DigitalSignatureLanding" },
        { label: "ASIC Forms Portal", route: "/FormsAndDocumentsLanding" },
      ],
    },
  ],
};

export const productLinks = [
  {
    key: "documents",
    label: "DOCUMENTS",
    tooltip: "Manage and store your company documents securely.",
    url: null, // placeholder – no current route
  },
  {
    key: "search",
    label: "KYC",
    tooltip: "Know Your Customer – identity verification and compliance.",
    isExternal: true, // links to Prime KYC environment
  },
];
